var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 94,
    viewBox: "0 0 74 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4243 86V77.306C11.4243 76.704 11.7603 76.494 12.1943 76.396C12.4743 76.34 13.1883 76.256 14.6443 76.256C17.5703 76.256 19.0263 77.46 19.0263 79.378C19.0263 80.722 18.3403 81.576 17.2203 82.066C18.0043 83.144 18.8583 84.782 19.4883 86H17.5563C17.2623 85.37 16.0863 83.172 15.5683 82.458C15.2463 82.5 14.8823 82.514 14.5883 82.514C13.9303 82.514 13.2863 82.458 13.0483 82.416V86H11.4243ZM13.0483 77.754V80.988C13.2863 81.03 13.7343 81.1 14.6443 81.1C16.6603 81.1 17.3183 80.4 17.3183 79.392C17.3183 78.468 16.7303 77.67 14.6023 77.67C13.6643 77.67 13.2023 77.712 13.0483 77.754ZM26.9486 81.758V85.972C26.5706 86.042 25.2966 86.196 23.8406 86.196C20.9286 86.196 20.2706 85.104 20.2706 83.928C20.2706 82.402 21.1526 81.604 23.6306 81.604C24.3446 81.604 25.0306 81.66 25.3526 81.702C25.3526 80.386 24.4706 80.064 23.2106 80.064C22.1466 80.064 21.5026 80.386 21.2926 80.554C21.1806 80.456 20.9146 80.19 20.9146 79.812C20.9146 79.28 21.4046 78.776 23.2386 78.776C25.4226 78.776 26.9486 79.574 26.9486 81.758ZM25.3666 84.908V82.864C25.1846 82.822 24.7086 82.724 23.6866 82.724C22.4126 82.724 21.8666 83.088 21.8666 83.914C21.8666 84.6 22.3006 85.034 23.8406 85.034C24.6946 85.034 25.1986 84.95 25.3666 84.908ZM28.5913 86V81.758C28.5913 79.896 30.0473 78.776 32.0073 78.776C33.9953 78.776 35.4233 79.896 35.4233 81.758V86H33.8273V82.164C33.8273 80.89 33.1973 80.218 32.0073 80.218C30.7893 80.218 30.1873 80.89 30.1873 82.164V86H28.5913ZM37.0405 86V76.424C37.0405 75.92 37.3485 75.682 37.8945 75.682C38.2305 75.682 38.5385 75.794 38.6365 75.836V81.562C39.1265 81.226 40.4985 80.176 41.5485 79.434C41.9545 79.14 42.2205 78.972 42.7665 78.972C43.2705 78.972 43.6485 79.336 43.7465 79.518C42.9625 80.232 40.7785 81.716 40.2045 82.136C41.7865 83.312 43.1305 84.768 44.0265 86H42.0385C41.1845 84.95 39.7985 83.704 38.6365 82.836V86H37.0405ZM44.9035 86V79.714C44.9035 79.196 45.2115 78.972 45.7575 78.972C46.0935 78.972 46.4015 79.084 46.4995 79.126V86H44.9035ZM45.7015 75.822C46.2475 75.822 46.6675 76.242 46.6675 76.788C46.6675 77.334 46.2475 77.754 45.7015 77.754C45.1555 77.754 44.7355 77.334 44.7355 76.788C44.7355 76.242 45.1555 75.822 45.7015 75.822ZM48.2104 86V81.758C48.2104 79.896 49.6664 78.776 51.6264 78.776C53.6144 78.776 55.0424 79.896 55.0424 81.758V86H53.4464V82.164C53.4464 80.89 52.8164 80.218 51.6264 80.218C50.4084 80.218 49.8064 80.89 49.8064 82.164V86H48.2104ZM57.1077 88.394L57.5417 87.204C57.7097 87.288 58.5637 87.652 59.7677 87.652C61.0277 87.652 62.3577 87.204 62.3577 85.146V84.978C61.9237 85.482 61.0977 86.028 59.9637 86.028C57.8777 86.028 56.3797 84.586 56.3797 82.458C56.3797 80.344 57.9757 78.776 60.2157 78.776C62.3437 78.776 63.9397 80.022 63.9397 82.766V84.782C63.9397 87.75 62.2457 88.94 59.9357 88.94C58.4097 88.94 57.4017 88.534 57.1077 88.394ZM60.2017 84.684C61.4617 84.684 62.3437 83.746 62.3437 82.458C62.3437 81.17 61.4617 80.218 60.2017 80.218C58.8997 80.218 58.0457 81.226 58.0457 82.458C58.0457 83.802 58.8997 84.684 60.2017 84.684Z",
    fill: "#FF2D55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10007_10356)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 28,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8375 38.5H27C25.625 38.5 24.5 39.625 24.5 41V48.5H32.8375V38.5Z",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6627 33.5H35.3252C33.9502 33.5 32.8252 34.625 32.8252 36V48.5H41.1627V36C41.1627 34.625 40.0502 33.5 38.6627 33.5Z",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0001 42.25H41.1626V48.5H49.5001V44.75C49.5001 43.375 48.3751 42.25 47.0001 42.25Z",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6503 23.5875L38.3128 24.9125C38.4003 25.1 38.6378 25.275 38.8378 25.3L40.0378 25.5C40.8003 25.625 40.9878 26.1875 40.4378 26.725L39.5003 27.6625C39.3378 27.825 39.2503 28.125 39.3003 28.3375L39.5628 29.4875C39.7753 30.4 39.2878 30.75 38.4878 30.275L37.3628 29.6125C37.1628 29.4875 36.8253 29.4875 36.6253 29.6125L35.5003 30.275C34.7003 30.75 34.2128 30.4 34.4253 29.4875L34.6878 28.3375C34.7378 28.125 34.6503 27.8125 34.4878 27.6625L33.5628 26.7375C33.0128 26.1875 33.1878 25.6375 33.9628 25.5125L35.1628 25.3125C35.3628 25.275 35.6003 25.1 35.6878 24.925L36.3503 23.6C36.7128 22.875 37.2878 22.875 37.6503 23.5875Z",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10007_10356",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10007_10356"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10007_10356",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRanking);
export default __webpack_public_path__ + "static/media/icon-ranking.e5a5cc5ed748cb85213219408285578b.svg";
export { ForwardRef as ReactComponent };